import { render, staticRenderFns } from "./page_details.vue?vue&type=template&id=84ee8a36&scoped=true&"
import script from "./page_details.vue?vue&type=script&lang=js&"
export * from "./page_details.vue?vue&type=script&lang=js&"
import style0 from "./page_details.vue?vue&type=style&index=0&id=84ee8a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee8a36",
  null
  
)

export default component.exports